import { all } from "redux-saga/effects";
import {
  watchDeleteAccountGoogle2FA,
  watchDeleteAccountSMS2FA,
  watchGetAccount2FAData,
  watchGetAccountBackupCodes2FA,
  watchGetAccountCredentialData,
  watchGetAccountResetBackupCodes2FA,
  watchGetLoginSessionData,
  watchGetProfileData,
  watchGetSitesSubscriptionList,
  watchPostAccountGoogle2FA,
  watchPostAccountSMS2FA,
  watchPostAccountSMS2FAVerify,
  watchSwitchToOwnedSite,
  watchSwitchToSharedSite,
  watchUpdateAccountSettingsData,
  watchUpdateLogOutSession,
  watchUpdateProfileData
} from "./accountSaga";
import {
  watchAppBasicInfo,
  watchAppVersion,
  watchAuthConfig,
  watchAuthLogin,
  watchAuthValidateToken,
  watchGetAllSites,
  watchGetAppFeature,
  watchGetAuthAppUsers,
  watchGetIntercomUserData,
  watchGetPermission,
  watchGetSharedSites,
  watchGetTrialPlanLimits,
  watchGetYourSites,
  watchOnboarding,
  watchUpdateAppBasicInfo,
  watchUpdateTokenLifetime
} from "./authSaga";
import { watchAppData, watchBillingSubscriptions, watchGetRecurlyAccountDetails, watchInvoices } from "./billingSaga";
import {
  watchAddRoleContext,
  watchAddSecondaryEmail,
  watchAssignRoles,
  watchBlockOrUnblockUser,
  watchConsumerAuditLogs,
  watchConsumerAuditLogsByUID,
  watchConsumerAuditLogsV1,
  watchConsumerAuditLogsByUIDV1,
  watchDeleteRoleContext,
  watchDeleteUser,
  watchGetAssignedRole,
  watchGetConsentLogs,
  watchGetCustomFields,
  watchGetESFields,
  watchGetPrivacyPolicyHistory,
  watchGetRoleContext,
  watchGetTwoFASettings,
  watchDeleteMFAFactor,
  watchGetMFAFactors,
  watchGetUserBySearchFields,
  watchGetUserIdentity,
  watchGetUsers,
  watchPostSessions,
  watchRemoveEmailAddressHandler,
  watchResendEmail,
  watchResetPassword,
  watchResetPin,
  watchSendResetPassword as watchSendResetPasswordManagement,
  watchUnassignRoles,
  watchUnlockUser,
  watchVerify,
  watchAddUser,
  watchGetCustomObjectData,
  watchLoadEnabledFieldSettings,
  watchUpdateUserProfile,
  watchGetCustomObjects,
  watchUserOrgs
} from "./customerManagementSaga";
import {
  watchDomainAccessRestriction,
  watchDuoSecondFactorAuth,
  watchGoogleAuthenticator,
  watchPasswordPolicy,
  watchPushNotify,
  watchSecondFactorAuth,
  watchSecurityquestions
} from "./securityConfigurationSaga";
import {
  watchAddConsentForm,
  watchAddConsentGroup,
  watchAddConsentOption,
  watchDataFieldsKey,
  watchDataObjectKey,
  watchDeleteConsentForm,
  watchEncryptionAtRest,
  watchGetConsentForm,
  watchGetConsentGroup,
  watchGetConsentOption,
  watchGetDataCenter,
  watchGetDataStorageLocation,
  watchGetHashingAlgorithm,
  watchGetPrivacyPolicyVersion,
  watchGetPrivacyPolicyVersionEnabled,
  watchPlatformRegistrationFields,
  watchPrivacyPolicy,
  watchSavePrivacyPolicyVersion,
  watchSavePrivacyPolicyVersionEnabled,
  watchSendAgeVerification,
  watchSiteRegistrationFormSettings,
  watchUpdateConsentForm,
  watchUpdateConsentLiveForm
} from "./dataConfigurationSaga";
import {
  watchAddMobileAppSott,
  watchAddWebApps,
  watchDeleteCustomDomain,
  watchDeleteProgressiveProfiling,
  watchGetCustomDomain,
  watchGetCustomField,
  watchGetCustomFieldLimit,
  watchAddCustomField,
  watchDeleteCustomField,
  watchGetMobileAppsSott,
  watchGetPlatformField,
  watchGetProgressiveProfiling,
  watchGetRegistrationField,
  watchGetWebApps,
  watchJSWidgetOptionalCaptcha,
  watchPostPlatformField,
  watchSaveCustomDomain,
  watchSMTPSettings,
  watchUpdateDataSchema,
  watchUpdateProgressiveProfiling,
  // watchVerifySMTPSettings,
  watchGetAllEmailTemplates,
  watchCreateEmailTemplate,
  watchUpdateEmailTemplate,
  watchResetEmailTemplate,
  watchDeleteEmailTemplate,
  watchSetDefaultEmailTemplate,
  watchGetEmailSettings,
  watchSaveEmailSettings,
  // watchSendTestEmail,
  watchGenerateEmailTemplateAI
} from "./deploymentSaga";
import {
  watchGetBestRegistrationStreaks,
  watchGetCreateDate,
  watchGetDeletedUsers,
  watchGetGrowthData,
  watchGetHighestGrowthData,
  watchGetLogsHosts,
  watchGetMonthlyHistory,
  watchGetRegisteredUsers,
  watchGetUserHosts,
  watchGetUserLogs,
  watchGetUsersData,
  watchGetWorstRegistrationStreaks,
  watchProviderData,
  watchReturnRate,
  watchTotalLogins
} from "./insightsSaga";
import {
  watchActivateIntegration,
  watchAddDataExportDumpRequest,
  watchAddWebHook,
  watchDeactivateIntegration,
  watchDeleteWebHook,
  watchGetAuditLogConfig,
  watchGetAuditLogLimits,
  watchGetAvailableIntegrations,
  watchGetDataExportDumpRequests,
  watchGetExportLogs,
  watchGetExportLogDownloadUrl,
  watchGetExportRecipients,
  watchGetIntegrationConfig,
  watchGetWebHookRequests,
  watchRemoveDataExportDumpRequest,
  watchResetAuditLogConfig,
  watchSaveAuditLogConfig,
  watchUpdateAuditLogConfig,
  watchSaveIntegrationData,
  watchUpdateWebHook,
  watchGetWebhookEvents,
  watchGetIntegrationList,
  watchGetIntegrationSubscriptions
} from "./integrationsSaga";
import {
  watchDeleteAuthServerApiConfig,
  watchDeleteMultipleSocialProvider,
  watchGetApiKey,
  watchGetAuthServerApiConfig,
  watchGetConfigurationList,
  watchGetCustomSMSProviderConfig,
  watchGetDataMapping,
  watchGetCustomProviderDataMapping,
  watchGetGlobalEmailConfig,
  watchGetGlobalSMSSettings,
  watchGetJWTProviders,
  watchGetMultipleSocialProvider,
  watchGetOAuthProviders,
  watchGetOIDCApps,
  watchGetOIDCandOAuthApps,
  watchGetSAMLApps,
  watchGetOptionalCaptcha,
  watchGetRoles,
  watchGetSAMLProviders,
  watchGetSMSProviderConfig,
  watchGetSMSSettingsAndConfig,
  watchGetSMSTemplates,
  watchGetSSOConnection,
  watchGetSocialProviderList,
  watchPostAuthServerApiConfig,
  watchPostMultipleSocialProvider,
  watchPostOIDCApps,
  watchPostOIDCandOAuthApps,
  watchPostRolesAndPermission,
  watchPostSSOIntegration,
  watchGetDefaultRole,
  watchPutDefaultRole,
  watchPutMultipleSocialProvider,
  watchPutOIDCApps,
  watchPutOIDCandOAuthApps,
  watchPutRolesAndPermission,
  watchRenewCertificate,
  watchResetSMSConfig,
  watchSaveCustomSMSConfig,
  watchSaveGlobalEmailConfig,
  watchSaveGlobalSMSSettings,
  watchSaveSMSConfig,
  watchSaveSMSSettings,
  watchSetAppFeature,
  watchTransferConfigurations,
  watchUpdateAuthServerApiConfig,
  watchGetAvailableSSOIntegration,
  watchDeleteSSOIntegration,
  watchDeleteRolesAndPermission,
  watchDeletePermissionOnly,
  watchDeleteOIDCandOAuthApps,
  watchDeleteOIDCApps,
  watchUpdatePassKeyConfig,
  watchGetPassKeyConfig,
  watchGetPasswordlessLoginSettings,
  watchUpdatePasswordlessLoginSettings,
  watchPostOAuthProviders,
  watchPutOAuthProviders,
  watchDeleteOAuthProviders,
  watchPostJWTProviders,
  watchDeleteJWTProviders,
  watchPostSAMLProviders,
  watchDeleteSAMLProviders,
  watchPutSAMLProviders,
  watchPutJWTProviders,
  watchGetSocialProviders,
  watchGetSocialProviderOption,
  watchPostSocialProviderOption,
  watchPostSocialProviders,
  watchPostAppleConfig,
  watchSocialProviderOrder,
  watchPostSAMLApps,
  watchPutSAMLApps,
  watchDeleteSAMLApps,
  watchGetHostedPluginApps,
  watchSaveHostedPlugin,
  watchDeleteHostedPlugin,
  watchGetJWTApps,
  watchPostJWTApps,
  watchPutJWTApps,
  watchDeleteJWTApps
} from "./platformConfigurationSaga";
import {
  watchAddPushNotification,
  watchGetAppBasicInfo,
  watchGetAppInfo,
  watchGetPasswordComplexityData,
  watchGetPinAuth,
  watchGetRiskAuthSettings,
  watchGetSecurityQuestions,
  watchGetWebhookSecrets,
  watchMfaGetAuthenticatorApps,
  watchMfaGetEmailStatus,
  watchMfaGetSecurityQuestions,
  watchMfaGetSettings,
  watchMfaGetSmsStatus,
  watchPriodicPasswordData,
  watchPushNotification,
  watchSecurityQuestions,
  watchUpdateMfaAuthenticatorApps,
  watchUpdateMfaEmailStatus,
  watchUpdateMfaGetSecurityQuestions,
  watchUpdateMfaSettings,
  watchUpdateMfaSmsStatus,
  watchUpdatePinAuthSettings,
  watchUpdatePushNotification,
  watchUpdateRiskAuthSettings,
  watchGetBreachedPasswordPolicy,
  watchPostBreachedPasswordPolicy,
  watchDuoAuthentication,
  watchUpdateDuoAuthentication,
  watchCaptchaSettings,
  watchUpdateCaptchaSettings,
  watchUpdateForceLogoutSetting,
  watchUpdateRemeberMeSetting,
  watchUpdateSessionLimitSetting,
  watchUpdateEventBasedReAuth,
  watchUpdateSpamEmailDomains,
  watchGetDomainAccessManagement,
  watchIpAccessManagement
} from "./securityConfigurationSaga";
import {
  watchDeleteSegment,
  watchGetAllCustomObjects,
  watchGetCustomObjTopTenUsers,
  watchGetCustomObjUsers,
  watchGetSegmentationsTopTenUsers,
  watchPostUserSegmentationQuery,
  watchSavedSegments
} from "./segmentationSaga";
import { watchGetCustomerData, watchGetExistingTickets, watchGetFilePickerKey, watchGetUsersForApp, watchsendTicketData } from "./supportSaga";
import {
  watchAuditLogs,
  watchDeleteSamlConfig,
  watchDeleteSelf,
  watchDeleteTeamUser,
  watchGetAppRoles,
  watchGetCurrentUser,
  watchGetTeamOwner,
  watchGetTeamUsers,
  watchLogOutTeamUser,
  watchInviteTeamMember,
  watchMapFields,
  watchOwnerInfo,
  watchPostSamlConfig,
  watchPutSamlConfig,
  watchResendTeamUserPassword,
  watchRoleList,
  watchSamlConfig,
  watchTransferAccount,
  watchUpdateCurrentUser,
  watchUpdateTeamUserRole,
  watchWasUserAddedInActiveSession,
  watchTeamAuditLogsV2
} from "./teamSaga";

import { watchGetAllWorkflows, watchGetAllScripts, watchInitWorkflowTemplateJSON } from "./workflowSaga";
import { watchCurrentOrganizationSaga, watchCurrentOrganizationUsersSaga, watchOrganizationSaga } from "./organizationSaga";
import { watchPermissionSaga, watchRoleSaga, watchTenantRoleSaga } from "./rolesSaga";
import watchInvitationsSaga from "./invitationsSaga";
import { watchGetResponseCodeData, watchPerformanceData, watchRequestCountData } from "./apiMetricsSaga";
import { watchBrandPagesSaga, watchHostedPagesSaga } from "./hostedPages";
import watchCustomDomainMappingSaga from "./customDomainMapping";
import { watchOAuthClientsSaga } from "./oauthClientsSaga";
import { watchUserConnectionsSaga } from "./userConnectionsSaga";
import { watchSigningKeys, watchAppSigningKeys } from "./signingKeysSaga";
import {
  watchGetOAuthIntegrations,
  watchCreateOAuthIntegration,
  watchUpdateOAuthIntegration,
  watchDeleteOAuthIntegration,
  watchRotateOAuthIntegrationCredentials,
  watchGetOAuthCatalogue,
  watchCreateOAuthIntegrationWrapper
} from "./oauthIntegrationsSaga";
import { watchSecurityHeaders } from "./securityHeadersSaga";

function* rootSaga() {
  yield all([
    // Auth
    watchGetAppInfo(),
    watchAuthConfig(),
    watchAuthLogin(),
    watchOnboarding(),
    watchAppBasicInfo(),
    watchAppVersion(),
    watchGetYourSites(),
    watchGetSharedSites(),
    watchGetSitesSubscriptionList(),
    watchSwitchToOwnedSite(),
    watchSwitchToSharedSite(),
    watchGetPermission(),
    watchGetAuthAppUsers(),
    // API Metrics
    // need to check again
    watchRequestCountData(),
    watchGetResponseCodeData(),
    watchPerformanceData(),
    // watchSmsAnalyticsData(),
    // watchSmsStatusData(),
    // watchLogsData(),

    // Insights
    watchGetCreateDate(),
    watchGetDeletedUsers(),
    watchGetGrowthData(),
    watchGetUserHosts(),
    watchGetRegisteredUsers(),
    watchGetUserLogs(),
    watchProviderData(),
    watchGetMonthlyHistory(),
    watchGetLogsHosts(),
    watchTotalLogins(),
    watchReturnRate(),
    watchGetHighestGrowthData(),
    watchGetBestRegistrationStreaks(),
    watchGetWorstRegistrationStreaks(),
    watchGetUsersData(),
    watchLoadEnabledFieldSettings(),
    watchAddUser(),
    watchGetIntercomUserData(),
    watchAppData(),
    watchBillingSubscriptions(),
    watchInvoices(),
    watchGetRecurlyAccountDetails(),
    watchGetTeamUsers(),
    watchGetTeamOwner(),
    watchDeleteTeamUser(),
    watchDeleteSelf(),
    watchResendTeamUserPassword(),
    watchLogOutTeamUser(),
    watchGetAppRoles(),
    watchUpdateTeamUserRole(),

    // ThirdParty Software - Configuration
    watchGetAvailableIntegrations(),
    watchGetIntegrationList(),
    watchGetIntegrationSubscriptions(),
    watchActivateIntegration(),
    watchDeactivateIntegration(),
    watchGetIntegrationConfig(),
    watchSaveIntegrationData(),

    watchGetProfileData(),
    watchUpdateProfileData(),
    watchGetAccountCredentialData(),
    watchGetLoginSessionData(),
    watchUpdateAccountSettingsData(),
    watchUpdateLogOutSession(),
    watchGetAccount2FAData(),
    watchPostAccountGoogle2FA(),
    watchDeleteAccountGoogle2FA(),
    watchPostAccountSMS2FAVerify(),
    watchPostAccountSMS2FA(),
    watchDeleteAccountSMS2FA(),
    watchGetAccountBackupCodes2FA(),
    watchGetAccountResetBackupCodes2FA(),

    // Deployment //webapps
    watchGetWebApps(),
    watchAddWebApps(),
    watchAuditLogs(),
    watchTeamAuditLogsV2(),
    watchRoleList(),
    watchOwnerInfo(),
    watchPostPlatformField(),

    // Deployment //Orchestration

    watchGetAllWorkflows(),
    watchGetAllScripts(),
    // Team Management - SSO
    watchMapFields(),
    watchSamlConfig(),
    watchPostSamlConfig(),
    watchPutSamlConfig(),
    watchDeleteSamlConfig(),

    watchGetCurrentUser(),

    // Team Management - Audit Logs and Add Team Member
    watchInviteTeamMember(),
    watchWasUserAddedInActiveSession(),

    watchTransferAccount(),
    watchUpdateCurrentUser(),

    // Custom Domain
    watchGetCustomDomain(),

    // Get Feature Permission
    watchGetAppFeature(),

    // JSWidget
    watchGetMobileAppsSott(),
    watchAddMobileAppSott(),
    watchGetDataExportDumpRequests(),
    watchRemoveDataExportDumpRequest(),
    watchAddDataExportDumpRequest(),
    watchGetCustomField(),
    watchGetPlatformField(),
    watchGetRegistrationField(),
    watchJSWidgetOptionalCaptcha(),
    watchGetExportLogs(),
    watchGetExportLogDownloadUrl(),
    watchGetExportRecipients(),
    watchGetWebHookRequests(),
    watchDeleteWebHook(),
    watchAddWebHook(),
    watchUpdateWebHook(),
    watchGetWebhookEvents(),

    // Support
    watchGetExistingTickets(),
    watchGetUsersForApp(),
    watchGetCustomerData(),
    watchGetFilePickerKey(),
    watchsendTicketData(),
    // Data Governance
    watchGetDataStorageLocation(),

    // password ploicy
    watchGetPasswordComplexityData(),
    watchPriodicPasswordData(),
    watchGetBreachedPasswordPolicy(),
    watchPostBreachedPasswordPolicy(),
    // watchPutPriodicPasswordData(),

    // Customer Management
    watchGetUserBySearchFields(),
    watchGetUsers(),
    watchGetUserIdentity(),
    watchPostSessions(),
    watchAddSecondaryEmail(),
    watchBlockOrUnblockUser(),
    watchDeleteUser(),
    watchUnlockUser(),
    watchVerify(),
    watchResetPassword(),
    watchResetPin(),
    watchSendResetPasswordManagement(),
    watchResendEmail(),
    watchRemoveEmailAddressHandler(),
    watchGetAssignedRole(),
    watchAssignRoles(),
    watchUnassignRoles(),
    watchGetRoleContext(),
    watchAddRoleContext(),
    watchDeleteRoleContext(),
    watchGetConsentLogs(),
    watchGetCustomFields(),
    watchGetESFields(),
    watchGetPrivacyPolicyHistory(),
    watchUserOrgs(),

    // Data Configuration
    watchEncryptionAtRest(),
    watchGetAppBasicInfo(),
    watchGetHashingAlgorithm(),
    watchPlatformRegistrationFields(),
    watchSiteRegistrationFormSettings(),
    watchDataObjectKey(),
    watchDataFieldsKey(),
    watchSendAgeVerification(),
    watchAddConsentGroup(),
    watchGetConsentGroup(),
    watchAddConsentOption(),
    watchGetConsentOption(),
    watchAddConsentForm(),
    watchUpdateConsentForm(),
    watchUpdateConsentLiveForm(),
    watchDeleteConsentForm(),
    watchGetConsentForm(),

    // Segementation
    watchPostUserSegmentationQuery(),
    watchGetSegmentationsTopTenUsers(),
    watchSavedSegments(),
    watchDeleteSegment(),
    watchGetAllCustomObjects(),
    watchGetCustomObjTopTenUsers(),
    watchGetCustomObjUsers(),

    // Risk based Auth
    watchGetRiskAuthSettings(),
    watchUpdateRiskAuthSettings(),

    // Platform Configuration
    watchGetSMSSettingsAndConfig(),
    watchGetSMSTemplates(),

    watchGetOAuthProviders(),
    watchPostOAuthProviders(),
    watchPutOAuthProviders(),
    watchDeleteOAuthProviders(),
    watchGetJWTProviders(),
    watchPostJWTProviders(),
    watchPutJWTProviders(),
    watchDeleteJWTProviders(),
    watchGetSAMLProviders(),
    watchPostSAMLProviders(),
    watchPutSAMLProviders(),
    watchDeleteSAMLProviders(),
    watchGetOIDCandOAuthApps(),
    watchGetSAMLApps(),
    watchPostSAMLApps(),
    watchPutSAMLApps(),
    watchDeleteSAMLApps(),
    watchGetJWTApps(),
    watchPostJWTApps(),
    watchPutJWTApps(),
    watchDeleteJWTApps(),
    watchGetOAuthIntegrations(),
    watchCreateOAuthIntegration(),
    watchUpdateOAuthIntegration(),
    watchDeleteOAuthIntegration(),
    watchRotateOAuthIntegrationCredentials(),
    watchGetOAuthCatalogue(),
    watchCreateOAuthIntegrationWrapper(),
    watchGetHostedPluginApps(),
    watchSaveHostedPlugin(),
    watchDeleteHostedPlugin(),
    watchGetSMSProviderConfig(),
    watchGetCustomSMSProviderConfig(),
    watchSaveSMSConfig(),
    watchSaveSMSSettings(),
    watchSaveCustomSMSConfig(),
    watchResetSMSConfig(),
    watchGetRoles(),
    watchPostRolesAndPermission(),
    watchPutRolesAndPermission(),
    watchDeleteRolesAndPermission(),
    watchDeletePermissionOnly(),
    watchGetDefaultRole(),
    watchPutDefaultRole(),
    watchGetConfigurationList(),
    watchGetSocialProviderList(),
    watchTransferConfigurations(),
    watchGetMultipleSocialProvider(),
    watchPostMultipleSocialProvider(),
    watchPutMultipleSocialProvider(),
    watchDeleteMultipleSocialProvider(),
    watchGetSSOConnection(),
    watchGetDataMapping(),
    watchGetCustomProviderDataMapping(),
    watchPostOIDCandOAuthApps(),
    watchPutOIDCandOAuthApps(),
    watchDeleteOIDCandOAuthApps(),
    watchGetOIDCApps(),
    watchPostOIDCApps(),
    watchPutOIDCApps(),
    watchDeleteOIDCApps(),

    watchMfaGetSecurityQuestions(),
    watchUpdateMfaGetSecurityQuestions(),
    watchMfaGetAuthenticatorApps(),
    watchUpdateMfaAuthenticatorApps(),
    watchMfaGetSettings(),
    watchUpdateMfaSettings(),
    watchMfaGetEmailStatus(),
    watchUpdateMfaEmailStatus(),
    watchMfaGetSmsStatus(),
    watchUpdateMfaSmsStatus(),
    watchPushNotification(),
    watchAddPushNotification(),
    watchUpdatePushNotification(),
    watchDuoAuthentication(),
    watchUpdateDuoAuthentication(),
    watchGetDomainAccessManagement(),
    watchDomainAccessRestriction(),
    watchIpAccessManagement(),

    // Trust Center
    watchSavePrivacyPolicyVersionEnabled(),
    watchSavePrivacyPolicyVersion(),
    watchGetPrivacyPolicyVersionEnabled(),
    watchGetPrivacyPolicyVersion(),

    // Email Configuration
    // watchVerifySMTPSettings(),

    // Email Templates
    watchGetAllEmailTemplates(),
    watchCreateEmailTemplate(),
    watchUpdateEmailTemplate(),
    watchResetEmailTemplate(),
    watchDeleteEmailTemplate(),
    watchSetDefaultEmailTemplate(),
    watchGetEmailSettings(),
    watchSaveEmailSettings(),
    // watchSendTestEmail(),
    watchGenerateEmailTemplateAI(),

    // Global Email Config
    watchGetGlobalEmailConfig(),
    watchSaveGlobalEmailConfig(),
    watchGetGlobalSMSSettings(),
    watchSaveGlobalSMSSettings(),

    watchGetApiKey(),
    watchUpdateAppBasicInfo(),
    watchUpdateDataSchema(),

    watchUpdateUserProfile(),
    watchGetCustomObjectData(),
    watchGetCustomObjects(),
    watchAuthValidateToken(),
    watchGetAllSites(),

    // ETL
    watchGetPinAuth(),
    watchUpdatePinAuthSettings(),
    watchGetSecurityQuestions(),
    watchGetWebhookSecrets(),
    watchGetAuthServerApiConfig(),
    watchDeleteAuthServerApiConfig(),
    watchUpdateAuthServerApiConfig(),
    watchPostAuthServerApiConfig(),

    watchSetAppFeature(),
    watchRenewCertificate(),
    watchSaveCustomDomain(),
    watchDeleteCustomDomain(),
    watchGetTwoFASettings(),
    watchDeleteMFAFactor(),
    watchGetMFAFactors(),

    watchGetAvailableSSOIntegration(),
    watchPostSSOIntegration(),
    watchDeleteSSOIntegration(),

    watchGetAuditLogConfig(),
    watchGetAuditLogLimits(),
    watchSaveAuditLogConfig(),
    watchUpdateAuditLogConfig(),
    watchResetAuditLogConfig(),

    watchGetDataCenter(),
    watchGetTrialPlanLimits(),

    watchSecurityQuestions(),
    watchGetOptionalCaptcha(),
    watchUpdatePassKeyConfig(),
    watchGetPassKeyConfig(),
    watchGetPasswordlessLoginSettings(),
    watchUpdatePasswordlessLoginSettings(),
    watchGetSocialProviderOption(),
    watchGetSocialProviders(),
    watchPostSocialProviderOption(),
    watchPostSocialProviders(),
    watchPostAppleConfig(),
    watchSocialProviderOrder(),

    // Consumer Audit Logs
    watchConsumerAuditLogs(),
    watchConsumerAuditLogsByUID(),
    watchConsumerAuditLogsV1(),
    watchConsumerAuditLogsByUIDV1(),

    // Captcha Settings
    watchCaptchaSettings(),
    watchUpdateCaptchaSettings(),

    watchUpdateTokenLifetime(),

    watchUpdateForceLogoutSetting(),
    watchUpdateRemeberMeSetting(),

    watchUpdateSessionLimitSetting(),
    watchUpdateEventBasedReAuth(),
    watchUpdateSpamEmailDomains(),
    watchInitWorkflowTemplateJSON(),
    watchCurrentOrganizationSaga(),
    watchOrganizationSaga(),
    watchRoleSaga(),
    watchPrivacyPolicy(),
    watchTenantRoleSaga(),
    watchPermissionSaga(),
    watchCurrentOrganizationUsersSaga(),
    watchInvitationsSaga(),
    watchSecondFactorAuth(),
    watchDuoSecondFactorAuth(),
    watchGoogleAuthenticator(),
    watchPushNotify(),
    watchPasswordPolicy(),
    watchSMTPSettings(),
    watchSecurityquestions(),
    watchGetProgressiveProfiling(),
    watchGetCustomFieldLimit(),
    watchAddCustomField(),
    watchDeleteCustomField(),
    watchUpdateProgressiveProfiling(),
    watchDeleteProgressiveProfiling(),
    watchHostedPagesSaga(),
    watchBrandPagesSaga(),
    watchCustomDomainMappingSaga(),
    watchOAuthClientsSaga(),
    watchSigningKeys(),
    watchAppSigningKeys(),
    watchSecurityHeaders(),
    watchUserConnectionsSaga()
  ]);
}
export default rootSaga;
